/**
 * ============================================================================
 *  APP · ROLES — who exists at this organisation.
 * ============================================================================
 *
 *  Roles are an APPLICATION decision, not a framework one. A different site built
 *  on this framework would declare a different set here and change nothing else.
 *
 *  `admin` is the one name the framework knows: it bypasses every check, which is
 *  why no section ever lists it.
 */
import { registerRole, type ADMIN_ROLE } from '@framework/core';

export enum Role {
  /** Must equal ADMIN_ROLE — asserted below. The framework registers this one. */
  Admin = 'admin',
  Editor = 'editor',
  Marketing = 'marketing',
  Viewer = 'viewer',
  /** The welcome team: follows up the messages visitors send through the contact form. */
  Welcome = 'welcome',
}

export const ALL_ROLES: readonly Role[] = Object.values(Role);

/**
 * Hand them to the framework. Until this ran, nothing in `framework/` could know this
 * site has an "editor" — which is exactly why the admin endpoint returned a list of
 * users with no list of roles to assign to them.
 *
 * Importing `@app/sections` is what fires this: the same side effect that populates
 * the section registry. Re-registering admin is harmless — the framework put it there.
 */
ALL_ROLES.forEach(registerRole);

/** Compile error if this drifts from the framework's admin name. */
const _adminMatches: typeof ADMIN_ROLE = Role.Admin;
void _adminMatches;
